import { createApp } from 'vue'
import App from './App.vue'
import 'normalize.css/normalize.css'
import 'regenerator-runtime/runtime'
import '../css/main.scss'
import './page.scss'

const app = createApp(App)
app.mount('#app')